module.exports = __webpack_public_path__ + "static/media/take-notice 2.1facabe4.png";